import { BaseModel } from "paliari-js-utils"
import DocModeloParams from "./DocModeloParams"
import DocTexto from "./DocTexto"

const attributes = {
  id: null,
  titulo: "",
  descricao: "",
  tipo: null,
  tipo_implantacao: "total",
  implantar_na_ciencia: false,
  autua_automaticamente: false,
  implantar_na_ciencia: false,
  implantar_ao_autuar: false,
  ciencia_automatica: false,
  ativo: true,
  prazo: 0,
  pontuacao: 0.0,
  situacao_na_ciencia_id: null,
  textos: (arr = []) => arr.map(i => new DocTexto(i)),
  termo_textos: arr => (arr ? arr.map(i => new DocTexto(i)) : null),
  debito_tipo_id: null,
  debito_tipo: obj => ({ ...obj }),
  params: obj => new DocModeloParams(obj),
  departamento_id: null,
  departamento: obj => ({ ...obj }),
}

class DocModelo extends BaseModel {
  constructor(obj) {
    super(attributes, obj)
    if (!obj || !obj.params) this.params = new DocModeloParams()
  }

  get postParams() {
    const { departamento, debito_tipo, ...data } = this

    return data
  }
}

export default DocModelo
